import React, { useState } from 'react';

import ReCAPTCHA from 'react-google-recaptcha';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

import { Popup } from '../Popup';
import { Loading } from './Loading';

const RECAPTCHA_PUBLIC_KEY = "6LdoTsgSAAAAAIH5TfbYlCAvGuvIKwSL8W3YdkSX";
const S3_PRESIGN_ENDPOINT = "https://y1n85zgyxk.execute-api.us-east-2.amazonaws.com/default/mikuTempUploadFile";

export const SubmitBotForm = ({ isPopUpOpen, setIsPopUpOpen }) => {
    const [captchaValue, setCaptchaValue] = useState('');
    const [botName, setBotName] = useState('');
    const [contact, setContact] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const submitCaptcha = async () => {
        if (!captchaValue) {
            toast.error("Please, complete captcha.");
            return
        }

        try {
            const response = await axios.get(S3_PRESIGN_ENDPOINT, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {
                    botName,
                    contact,
                    recaptchaResponse: captchaValue
                }
            });

            return response?.data?.url || '';
        } catch (error) {
            console.error("Error: ", error);
            return '';
        }
    };

    const handleUploadFile = async (event) => {
        event.preventDefault();

        const fileUploadInput = document.getElementById("file-upload");
        const file = fileUploadInput.files[0];

        if (!file) {
            toast.error("Please, select a file.");
            return
        }

        const reader = new FileReader();

        setIsLoading(true);
        reader.addEventListener('load', async (event) => {
            const fileData = event.target.result;

            try {
                const presignedUrl = await submitCaptcha();
                if (presignedUrl) {
                    await axios.put(presignedUrl, fileData);
                    toast.success("File uploaded successfully.");
                    setIsPopUpOpen(false);
                    setIsLoading(false);
                } else {
                    console.error("There was an trying to get presigned url.");
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("There was an error uploading the file.", error);
                setIsLoading(false);
            }
        });

        reader.readAsArrayBuffer(file);
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value)
    };

    return (
        <Popup isPopUpOpen={isPopUpOpen} setIsPopUpOpen={setIsPopUpOpen}>
            <div className="SubmitBotForm">
                <h1>Submit your bot</h1>
                <form className='form' onSubmit={handleUploadFile}>
                    <div className='input-label'>
                        <label htmlFor="contact">Please indicate the bot name</label>
                        <input type="text" id="contact" name="contact" placeholder='Bot Name' value={botName} onChange={(e) => setBotName(e.target.value || '')} />
                    </div>
                    <div className='input-label'>
                        <label htmlFor="contact">Please indicate your email or discord name so we can contact you in case we have a problem with your bot:</label>
                        <input type="text" id="contact" name="contact" placeholder='Email or discord user' value={contact} onChange={(e) => setContact(e.target.value || '')} />
                    </div>
                    <div className='input-label'>
                        <label htmlFor="file-upload">Upload ".miku.json" file:</label>
                        <input type="file" id="file-upload" accept=".json" name='file'/>
                    </div>
                    {
                        !isLoading ? (
                            <ReCAPTCHA
                                sitekey={RECAPTCHA_PUBLIC_KEY}
                                onChange={handleCaptchaChange}
                            />
                        ) : null
                    }
                    {
                        isLoading ? <Loading /> : <button className='send-button' type='submit' disabled={!captchaValue}>SEND</button>
                    }
                </form>
            </div> 
        </Popup>
    )
};
